import { IncidentWorkItemStatusSchema } from "@thalamos/common";
import type { ActionInput } from "../ActionInput.js";
import { calculateIncidentWorkItemStatus } from "../calculateIncidentWorkItemStatus.js";
import {
  hasPlaceOfSafety,
  hasTriageForm,
  incidentIsActive,
  userIsIncidentOwner,
} from "../helpers.js";
import { match } from "ts-pattern";

type AddPlaceOfSafetyAction = {
  canAdd: boolean;
};

type EditPlaceOfSafetyAction = {
  canEdit: boolean;
};

type PlaceOfSafetyActions = AddPlaceOfSafetyAction & EditPlaceOfSafetyAction;

function canAddPlaceOfSafety(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput)
  );
}

function formHasBeenAccessedOrShared(actionInput: ActionInput): boolean {
  return match(
    calculateIncidentWorkItemStatus(actionInput.incidentWorkItem).unwrapOr(
      IncidentWorkItemStatusSchema.enum.unknown,
    ),
  )
    .with(
      "form-shared",
      "nhs-form-accepted",
      "police-presence-requested",
      "police-presence-not-requested",
      "ended",
      () => true,
    )
    .with(
      "in-progress",
      "awaiting-arrival",
      "arrived-at-place-of-safety",
      "unknown",
      () => false,
    )
    .exhaustive();
}

function canEditPlaceOfSafety(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    hasPlaceOfSafety(actionInput) &&
    !formHasBeenAccessedOrShared(actionInput)
  );
}

export function calculatePlaceOfSafetyActions(
  actionInput: ActionInput,
): PlaceOfSafetyActions {
  return {
    canAdd: canAddPlaceOfSafety(actionInput),
    canEdit: canEditPlaceOfSafety(actionInput),
  };
}
